// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__qjX7L","author":"Table_author__D6epz","authorImage":"Table_authorImage__1Ygeg","unreadRow":"Table_unreadRow__1GTwu"};